<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="display-1 text-center">Advertise On TeamHive.live</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
        <v-col cols="12" md="6" class="justify-self-center">
          <p class="text-center">
            There are many effective ways for your company to advertise on TeamHive.live, to learn more, please contact Faylyn Catmull at:
          </p>
          <p class="mb-0 text-center">
            <a href="mailto:f.catmull@centracom.com?subject=Advertise on TeamHive.live">f.catmull@centracom.com</a>
          </p>
          <p class="text-center">
            435.427.0646
          </p>
        </v-col>
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
      </v-row>
      <v-divider style="width: 75%;" class="mx-auto my-7"></v-divider>
    </v-container>
  </div>
</template>
<script>
export default {
  data: () => ({}),
};
</script>
